import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { GetAppLink } from "./GetAppLink";
import { ComingSoonBanner } from "./ComingSoonBanner";
import { useT } from "../../i18n/LangContext";

const pill = "rounded-full px-3 py-1.5 text-sm font-medium text-black transition-colors hover:bg-[#F3F3F3]";

const LangSwitch = ({ t }) => (
  <Link
    to={t.lang === "en" ? `/el${t.slug}` : t.slug || "/"}
    hrefLang={t.lang === "en" ? "el" : "en"}
    aria-label={t.switcher.aria}
    onClick={() => window.scrollTo(0, 0)}
    className={`${pill} flex items-center gap-1.5`}
    data-testid="lang-switch"
  >
    <span>{t.lang.toUpperCase()}</span>
    <span className="text-zinc-500">/</span>
    <span className="text-zinc-600">{t.switcher.label}</span>
  </Link>
);

export const Header = () => {
  const t = useT();
  const base = t.slug ? t.home : "";
  return (
    <header className="sticky top-0 z-50 border-b border-black/5 bg-white" data-testid="site-header">
      <ComingSoonBanner />
      <div className="px-5 sm:px-8">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between">
        <div className="flex items-center gap-6">
          <a href={t.slug ? t.home : "#top"} aria-label={t.homeAria} data-testid="header-logo-link">
            <Logo />
          </a>
          <nav className="hidden items-center gap-1 lg:flex" aria-label="Main">
            {t.nav.map((n) => (
              <a key={n.href} href={base + n.href} className={pill} data-testid={`nav-${n.href.slice(1)}`}>
                {n.label}
              </a>
            ))}
          </nav>
        </div>
        <div className="flex items-center gap-1 sm:gap-2">
          <LangSwitch t={t} />
          <a href={`${base}#help`} className={`${pill} hidden sm:inline-block`} data-testid="header-help-link">
            {t.help}
          </a>
          <GetAppLink
            fallback={`${base}#download`}
            className="hidden rounded-full bg-black px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-zinc-800 sm:inline-flex"
            testid="header-get-app-btn"
          >
            {t.getApp}
          </GetAppLink>
        </div>
      </div>
      </div>
    </header>
  );
};
